var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAligarhi01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195,358.64v11.54c0,1.52,0,3,.07,4.54.06,3,.14,6,.24,8.89.26,7.75.66,15.29,1.16,22.56,0,.76.1,1.5.16,2.25.52,7.47,1.16,14.65,1.87,21.47-5.45.75-17.39,2.52-23,2.95s-11.55-1.61-17.21-1.51c-.17-3.58-.34-7.12-.51-10.6q-1-20.07-1.88-37.91-.15-3.17-.33-6.26c-.1-1.85-.19-3.68-.29-5.5q-.5-8.74-1-17-.33-5.46-.69-10.77c0-.64-.09-1.28-.13-1.92-1.78-26.39,0-49.61-1.54-67.74-3-35.86-11-72-6-123.34,2.12-21.79,5.17-39.72,7.55-51.94l58,4.19q-.15,49.2-.34,98.39c-10,36.14-12.61,78.47-15.39,129.94q-.44,7.92-.62,15.73Q195.06,352.65,195,358.64Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,275.51c-1.53,18.13.24,41.35-1.54,67.74-.1,1.49-.19,3-.27,4.51-.57,10.76-.65,22-.67,33.87v17.54c0,3.7,0,7.47-.11,11.31-.05,3.62-.13,7.28-.24,11s-.26,7.62-.44,11.72c-5.67-.1-17.42.43-23.16,0-5.58-.43-11.76-1.9-17.21-2.66q.72-7,1.16-14.39c.22-3.47.38-7,.51-10.6v-.95c0-1.33.08-2.67.11-4,0-1,0-2.07.07-3.12.06-2.58.09-5.19.09-7.81q0-7.38-.1-15-.09-6.42-.32-13-.45-13.83-1.25-28.4c-2.78-51.47-6.74-96.25-16.72-132.39q-.15-49.18-.34-98.39l58-4.19c2.38,12.22,5.43,30.15,7.55,51.94C282.07,201.56,275,239.66,272,275.51Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.72,97.56c5.16,5.17,16.91,4.78,16.91,4.78,12.9-.43-.32,2,31.21,2.24,15.69.13,23.54.2,34.57-.78a259,259,0,0,0,33.8-5.26c.33-1.86-.06-2.7-.48-3.12s-.93-.49-1.05-1,.63-.91.67-1.75-.9-1.14-1-2.25c0-.61.24-.64.48-1.75s.39-1.85,0-2.25-1.48.42-3.46.39c-1.66,0-1.78-.69-3-.48-1.64.28-1.9,1.64-3.16,1.56-1.06-.07-1.13-1-2.31-1.17s-1.28.59-2.88,1-1.6-.19-3.27.1c-1.84.32-1.9,1-3.36,1.07s-1.57-.63-3.07-.58-1.53.64-3.07.87-1.93-.35-3.84-.39c-2.14,0-2,.71-4.23.78s-2.65-.72-5-.48c-1.34.13-1.34.41-2.69.48-1.85.11-2.05-.39-3.84-.39-2,0-2.12.63-4.13.59-1.62,0-1.55-.43-3.17-.49-2.13-.08-2.49.6-4.61.59-1.76,0-1.6-.48-3.56-.59-2.3-.13-2.55.52-5.09.49-1.82,0-1.79-.36-3.84-.39-2.26,0-2.26.38-4,.29-2.48-.11-2.75-.93-5-.88-1.78,0-1.66.56-3.37.59-2.39,0-2.69-1-5.09-1-2,0-2.07.73-3.74.49-2.07-.29-2.27-1.45-3.94-1.36s-2,1.1-3.36.78c-.85-.21-.75-.65-1.73-1-1.49-.5-2,.42-3.55,0-1.17-.32-1.2-1-2.31-1.07s-1.08.4-2,.39c-1.63,0-2-1.49-3.27-1.37a3.08,3.08,0,0,0-2.21,2.34c-.27,1.15.39,1.5.29,3.42a7.41,7.41,0,0,1-.38,2.14c-.44,1.27-1,1.55-1,2.34A3,3,0,0,0,153.72,97.56Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.98
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.88,90.54a18.42,18.42,0,0,1,4.61.68c1.68.49,2.29,1,3.84,1.08,1.74.13,1.77-.4,3.36-.3,2.18.14,2.62,1.17,5.09,1.56,1.61.26,1.52-.17,3.17,0,3.78.4,4.66,2.69,7.1,2.25,1.57-.29,1.42-1.27,3.27-1.76s2.66.31,5.57.88a49.71,49.71,0,0,0,8,.29c2.65,0,4,0,5-.1,3.84-.38,4.8-1.2,7-.58a17.45,17.45,0,0,0,3.08.88,12.13,12.13,0,0,0,3.07,0c3.71-.39,3.85-1,6-1.08,2.94-.11,3.18,1.06,6,.78,2.19-.21,2-.88,4.13-1.07,2.89-.25,3.42.93,6.34.59,1.7-.21,1.84-.65,3.56-.69,2,0,2.2.54,3.84.49,2.26-.07,2.34-1.22,5-1.66,2.19-.36,2.39.39,4.61-.09,1.85-.41,1.89-1,3.55-1.17,1.83-.24,2.32.36,4,.19a8,8,0,0,0,3.65-1.37",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "158.91 93.1 158.91 94.96 157.85 95.86 157.85 97.37",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "162.33 93.73 162.33 95.59 161.28 96.49 161.28 97.99",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "167.1 94.96 167.1 96.82 166.04 97.72 166.04 99.22",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "171.62 95.23 171.62 97.09 170.57 97.99 170.57 99.5",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "176.58 95.86 176.58 97.72 175.52 98.62 175.52 100.13",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "180.52 97.09 180.52 98.95 179.46 99.85 179.46 101.35",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "184.94 97.37 184.94 99.22 183.88 100.13 183.88 101.63",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "241.69 97.09 241.69 98.95 242.75 99.85 242.75 101.35",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "247.45 96.64 247.45 98.5 248.51 99.4 248.51 100.91",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "252.7 95.86 252.7 97.72 253.76 98.62 253.76 100.13",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "257.75 94.96 257.75 96.82 258.8 97.72 258.8 99.22",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "261.5 94.28 261.5 96.13 262.56 97.03 262.56 98.54",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "265.1 93.4 265.1 95.25 266.16 96.16 266.16 97.66",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.26,
    y1: 97.37,
    x2: 188.1,
    y2: 101.95,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.46,
    y1: 97.83,
    x2: 192.31,
    y2: 102.42,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.88,
    y1: 97.83,
    x2: 196.73,
    y2: 102.42,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 201.9,
    y1: 97.83,
    x2: 200.75,
    y2: 102.42,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.18,
    y1: 98.15,
    x2: 204.99,
    y2: 102.88,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 210.02,
    y1: 98.15,
    x2: 209.83,
    y2: 102.88,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.63,
    y1: 98.15,
    x2: 214.44,
    y2: 102.88,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.87,
    y1: 98.19,
    x2: 219.71,
    y2: 102.84,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.74,
    y1: 98.19,
    x2: 224.58,
    y2: 102.84,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228.44,
    y1: 97.8,
    x2: 229.27,
    y2: 102.45,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.72,
    y1: 97.17,
    x2: 233.55,
    y2: 101.82,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.87,
    y1: 97.33,
    x2: 237.71,
    y2: 101.98,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.99
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.78,106.43c2.86,5.77-6.24,31.9-2.85,63.11,1.75,16.14-7.64,26.6-13.59,32",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.45,104.66c-2.85,5.77-.79,29.87,10.59,60.79,5.61,15.23-.1,28.91,5.86,34.32",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223,108.46c1.16,10.24-.63,23.71,2.71,40,2.48,12.15-7.76,21.85-10.71,30.2",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.23,104.66c-1.45,12.78-4.4,30.51,2.65,48.51,5.64,14.41,3.65,28.72,7.33,39.14",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAligarhi01);
export default __webpack_public_path__ + "static/media/ALIGARHI-01.a7360276925b9e44251fa39e2b62154c.svg";
export { ForwardRef as ReactComponent };